import React, { useState, useEffect } from 'react';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import EditRemainModal from '../../../components/Modal/EditRemainModal';

// Utils
import {
    getDataWithComp,
    getAlert,
    formatCurrency
} from '../../../../utils/SamuiUtils';

import {
    formatDateAndTime,
} from '../../../../utils/DateUtils';

function Form({ name }) {
    const [formArList, setFormArList] = useState([]);
    const [formItemHistory, setFormItemHistory] = useState([]);
    const [arId, setArId] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterOption, setFilterOption] = useState('pending');
    const [filteredArList, setFilteredArList] = useState([]);

    // Modal ปรับปรุงยอดค้างชำระ
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        initialize();
    }, []);

    useEffect(() => {
        // เคลียร์ก่อน
        setFilteredArList([]);

        const timeout = setTimeout(() => {
            const newList = formArList
                .filter((item) => {
                    const matchesSearch =
                        item.AR_Code.includes(searchTerm) ||
                        item.AR_Name.includes(searchTerm);

                    let matchesFilter = true;
                    if (filterOption === "pending") {
                        matchesFilter = item.Item_Onhand < 0;
                    } else if (filterOption === "not_pending") {
                        matchesFilter = item.Item_Onhand >= 0;
                    }

                    return matchesSearch && matchesFilter;
                })
                .reduce((acc, current) => {
                    // Check if the AR_Code or AR_Name already exists in the accumulator
                    if (!acc.some(item => item.AR_Code === current.AR_Code || item.AR_Name === current.AR_Name)) {
                        acc.push(current);
                    }
                    return acc;
                }, []);

            setFilteredArList(newList);
        }, 50);

        return () => clearTimeout(timeout);
    }, [formArList, searchTerm, filterOption]);

    const initialize = async () => {
        try {
            // เคลียค่าทุกครั้ง เมื่อเปิดหน้าจอ
            setFormArList([]);
            setFormItemHistory([]);

            // ค้นหาข้อมูลตั้งต้นจาก API_0002_Set_Item
            const arList = await getDataWithComp('API_1801_ITEM_REMAIN_ONHAND', `ORDER BY AR_Code ASC`);
            if (arList && arList.length > 0) {
                setFormArList(arList);
            }
        } catch (error) {
            getAlert('FAILED', error.message);
        }
    };

    // API_1901_ITEM_REMAIN_STC (ประวัติค้างถัง)
    const onRowSelectHistory = async (arId) => {
        try {
            setArId(arId);

            setFormItemHistory([]);

            const itemHistory = await getDataWithComp('API_1901_ITEM_REMAIN_STC', `AND Item_Id = ${arId} ORDER BY STC_SEQ DESC`);

            if (itemHistory && itemHistory.length > 0) {
                setFormItemHistory(itemHistory);
            }
        } catch (error) {
            getAlert('FAILED', error.message);
            setFormItemHistory([]);
        }
    };

    const openModal = (item) => {
        setSelectedItem(item);
        setModalOpen(true);
    };

    const closeModal = () => {
        setSelectedItem(null);
        setModalOpen(false);
    };

    return (
        <>
            <Breadcrumbs page={'ตรวจสอบคืนถัง'} items={[
                { name: 'คลังสินค้า', url: '/warehouse' },
                { name: name, url: '/remain-stock' },
            ]} />
            <div className="row mt-1 hidden-scrollbar" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                <div className="col-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="container-fluid">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                                        <h5 className="card-title mt-2 mb-2 text-center">ลูกค้าทั้งหมด</h5>
                                        <div className="input-group" style={{ maxWidth: "300px" }}>
                                            <span className="input-group-text">🔍</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                placeholder="ค้นหา รหัสลูกค้า หรือ ชื่อลูกค้า"
                                            />
                                        </div>

                                        <div className="d-flex flex-column align-items-end ms-auto">
                                            <div className="radio-inline">
                                                <div className="form-check form-check-inline form-check-lg me-2">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="filterOption"
                                                        value="pending"
                                                        checked={filterOption === "pending"}
                                                        onChange={() => setFilterOption("pending")}
                                                    />
                                                    ค้างถัง
                                                </div>
                                                <div className="form-check form-check-inline form-check-lg me-2">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="filterOption"
                                                        value="not_pending"
                                                        checked={filterOption === "not_pending"}
                                                        onChange={() => setFilterOption("not_pending")}
                                                    />
                                                    ไม่ค้างถัง
                                                </div>
                                                <div className="form-check form-check-inline form-check-lg">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="filterOption"
                                                        value="all"
                                                        checked={filterOption === "all"}
                                                        onChange={() => setFilterOption("all")}
                                                    />
                                                    แสดงทั้งหมด
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="card-body">
                                <div className="table-responsive" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                    <table id="basic-datatables" className="table table-striped table-hover">
                                        <thead className="thead-dark">
                                            <tr>
                                                <th className="text-center" style={{ width: '1%' }}>#</th>
                                                <th className="text-center" style={{ width: '17%' }}>รหัสลูกค้า</th>
                                                <th className="text-center" style={{ width: '60%' }}>ชื่อลูกค้า</th>
                                                <th className="text-center" style={{ width: '20%' }}>คงเหลือ</th>
                                                <th className="text-center" style={{ width: '2%' }}>จัดการ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredArList.length > 0 ? (
                                                filteredArList.map((item, index) => (
                                                    <tr
                                                        key={item.AR_Id}
                                                        onClick={() => {
                                                            onRowSelectHistory(item.AR_Id);
                                                        }}
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: arId === item.AR_Id ? 'rgb(105, 188, 216)' : 'transparent',
                                                            transition: 'background-color 0.3s ease'
                                                        }}
                                                    >
                                                        <td className="text-center">{index + 1}</td>
                                                        <td className="text-center">{item.AR_Code}</td>
                                                        <td className="text-left">{item.AR_Name}</td>
                                                        <td
                                                            className="text-end"
                                                            style={{
                                                                color: item.Item_Onhand < 0 ? 'red' : item.Item_Onhand > 0 ? 'green' : 'inherit',
                                                                fontWeight: 'bold'
                                                            }}
                                                        >
                                                            {formatCurrency(item.Item_Onhand)}
                                                        </td>
                                                        <td className="text-center">
                                                            <i
                                                                className="fa fa-pen"
                                                                style={{ color: '#EF6C00', cursor: 'pointer' }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    openModal(item);
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={7}>
                                                        <center>
                                                            <h5>ไม่พบข้อมูล</h5>
                                                        </center>
                                                    </td>
                                                </tr>
                                            )}

                                            <EditRemainModal
                                                isOpen={isModalOpen}
                                                onClose={closeModal}
                                                item={selectedItem}
                                                initialize={initialize}
                                            />
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-8">
                    <div className={`tab-pane fade show active`} role="tabpanel">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="container-fluid">
                                        <div className="d-flex flex-row">
                                            <h5 className="card-title mt-3 me-4 text-center">ประวัติยอดค้างถังเคลื่อนไหว</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table id="basic-datatables" className="table table-striped table-hover">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th className="text-center" style={{ width: '1%' }}>#</th>
                                                    <th className="text-center" style={{ width: '14%' }}>ประเภท</th>
                                                    <th className="text-center" style={{ width: '15%' }}>จำนวน</th>
                                                    <th className="text-center" style={{ width: '15%' }}>ยอดถังคงเหลือ</th>
                                                    <th className="text-center" style={{ width: '15%' }}>วันที่ทำรายการ</th>
                                                    <th className="text-center" style={{ width: '10%' }}>เลขเอกสาร</th>
                                                    <th className="text-center" style={{ width: '10%' }}>เอกสารอ้างอิง</th>
                                                    <th className="text-center" style={{ width: '20%' }}>หมายเหตุ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formItemHistory.length > 0 ? (
                                                    formItemHistory.map((item, index) => (
                                                        <tr key={item.STC_Id}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td className="text-center">{item.Doc_Type === 'AO' ? 'ค้างไว้' : 'คืนแล้ว'}</td>
                                                            <td className="text-center">
                                                                {
                                                                    item.Doc_Type === 'TO'
                                                                        || item.Doc_Type === 'AO'
                                                                        || item.Doc_Type === 'OUT' ? '-' : ''
                                                                }
                                                                {formatCurrency(Math.abs(item.STC_QTY))}
                                                            </td>
                                                            <td className="text-center">{formatCurrency(item.STC_Balance)}</td>
                                                            <td className="text-center">{formatDateAndTime(item.STC_Date)}</td>
                                                            <td className="text-center">{item.Doc_No}</td>
                                                            <td className="text-center">
                                                                {item.Doc_NoRef && item.Doc_NoRef.split('ยกเลิก').map((part, index, array) => (
                                                                    <React.Fragment key={index}>
                                                                        {part}
                                                                        {index < array.length - 1 && (
                                                                            <span style={{ color: 'red', fontWeight: 'bold' }}>
                                                                                <strong>ยกเลิก</strong>
                                                                            </span>
                                                                        )}
                                                                    </React.Fragment>
                                                                ))}
                                                            </td>
                                                            <td className="text-center">{item.STC_Remark || '-'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <center>
                                                                <h5>ไม่พบข้อมูล</h5>
                                                            </center>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Form;